import React from "react";
import "../ProductCardsModems.css";
import { Link } from "react-router-dom"; 
import '../../i18n';
import { useTranslation } from 'react-i18next';

import ImageSpin26HTransponder from "../../assets/images/modems/processed/combined_transponder_spin26H.png"

const Spin26H_BEACON = () => {
  const { t, i18n } = useTranslation();
  
  return (
     <Link to="/acoustic_modems#spin26H_beacon_spec" className="card-link-wrapper">
        <div class="card-beacon">
          <img src={ImageSpin26HTransponder} alt={t('products.types.communcation_26H_BEACON.title')} class="card-image-beacon" />
          <div class="card-content">
            <h3 class="card-title">{t('products.types.communcation_26H_BEACON.title')}</h3>
            <p className="card-description">
              <ul class="features-list">
                <li>{t('products.types.communcation_26H_BEACON.li_1')}</li>
                <li>{t('products.types.communcation_26H_BEACON.li_2')}</li>
                <li>{t('products.types.communcation_26H_BEACON.li_3')}</li>
                <li>{t('products.types.communcation_26H_BEACON.li_4')}</li>
                <li>{t('products.types.communcation_26H_BEACON.li_5')}</li>
                <li>{t('products.types.communcation_26H_BEACON.li_6')}</li>
              </ul>
            </p>
          </div>
        </div>
      </Link>
  );
};
export default Spin26H_BEACON;